module.exports = __webpack_public_path__ + "static/media/7.3e1d5071.svg";